<template>
  <svg
    width="71"
    height="52"
    viewBox="0 0 71 52"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <rect width="71" height="52" fill="white" />
    <path
      opacity="0.8"
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M55.2019 3.72282C55.2019 4.82316 54.3099 5.71516 53.2096 5.71516C52.1092 5.71516 51.2172 4.82316 51.2172 3.72282C51.2172 2.62247 52.1092 1.73047 53.2096 1.73047C54.3099 1.73047 55.2019 2.62247 55.2019 3.72282ZM35.0973 48.8223C47.6012 48.8223 57.7376 38.6859 57.7376 26.182C57.7376 13.6781 47.6012 3.54169 35.0973 3.54169C22.5934 3.54169 12.457 13.6781 12.457 26.182C12.457 38.6859 22.5934 48.8223 35.0973 48.8223ZM65.1637 15.858C67.2643 15.858 68.9672 14.1551 68.9672 12.0544C68.9672 9.95379 67.2643 8.25088 65.1637 8.25088C63.063 8.25088 61.3601 9.95379 61.3601 12.0544C61.3601 14.1551 63.063 15.858 65.1637 15.858ZM14.4494 50.6335C15.1496 50.6335 15.7172 50.0659 15.7172 49.3657C15.7172 48.6655 15.1496 48.0978 14.4494 48.0978C13.7492 48.0978 13.1815 48.6655 13.1815 49.3657C13.1815 50.0659 13.7492 50.6335 14.4494 50.6335Z"
      fill="url(#paint0_radial_410_32631)"
    />
    <path
      d="M20.9945 21.1855C20.6804 20.4186 21.0486 19.5418 21.8169 19.2271L38.8578 12.2478C39.6261 11.9332 40.5035 12.2998 40.8176 13.0666L49.4904 34.2425C49.8045 35.0093 49.4363 35.8861 48.668 36.2008L31.6271 43.1801C30.8588 43.4948 29.9814 43.1281 29.6673 42.3613L20.9945 21.1855Z"
      fill="url(#paint1_radial_410_32631)"
    />
    <path
      d="M24.8906 15.5591C24.8906 14.7304 25.5637 14.0586 26.3939 14.0586H44.8087C45.6389 14.0586 46.3119 14.7304 46.3119 15.5591V38.4421C46.3119 39.2708 45.6389 39.9427 44.8087 39.9427H26.3939C25.5637 39.9427 24.8906 39.2708 24.8906 38.4421V15.5591Z"
      fill="url(#paint2_radial_410_32631)"
    />
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M39.9868 11.977C39.7455 12.0294 39.4933 12.1898 39.2942 12.5346L36.9375 16.6166C36.8705 16.7327 36.8739 16.8523 36.948 16.9889C37.0274 17.1355 37.1838 17.2852 37.3843 17.3974C37.5844 17.5094 37.7977 17.5667 37.9693 17.561C38.1337 17.5555 38.2337 17.4967 38.2908 17.3979L39.7862 14.8078C39.8375 14.7189 39.8343 14.6543 39.82 14.61C39.8035 14.5592 39.7631 14.5083 39.7028 14.4735C39.6426 14.4388 39.5783 14.4291 39.5261 14.4403C39.4806 14.4501 39.423 14.4796 39.3717 14.5685L38.2248 16.5549C38.1427 16.6972 37.9607 16.7459 37.8184 16.6638C37.6761 16.5816 37.6274 16.3997 37.7095 16.2574L38.8564 14.271C38.9868 14.0451 39.1818 13.9055 39.4015 13.8585C39.6145 13.8129 39.8281 13.8588 40.0004 13.9582C40.1726 14.0576 40.3191 14.2197 40.3861 14.4269C40.4553 14.6408 40.4319 14.8794 40.3015 15.1053L38.8061 17.6954C38.6203 18.0172 38.301 18.1453 37.9891 18.1557C37.6844 18.1659 37.3643 18.0681 37.0937 17.9166C36.8234 17.7653 36.5716 17.5433 36.4248 17.2725C36.2727 16.9918 36.2319 16.6486 36.4222 16.3191L38.7789 12.2371C39.0531 11.7622 39.4389 11.4871 39.8604 11.3955C40.2756 11.3053 40.6966 11.3993 41.0394 11.6067C41.7262 12.0221 42.1537 12.9371 41.6131 13.8735L41.4644 14.1311L40.9491 13.8336L41.0978 13.576C41.4491 12.9676 41.1904 12.3935 40.7314 12.1158C40.5013 11.9766 40.2345 11.9231 39.9868 11.977Z"
      fill="url(#paint3_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="17.9258"
      width="8.92554"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint4_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="20.3066"
      width="4.46277"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint5_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="23.5801"
      width="18.1486"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint6_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="26.2578"
      width="18.1486"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint7_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="31.6113"
      width="18.1486"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint8_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="28.9336"
      width="14.8759"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint9_radial_410_32631)"
    />
    <rect
      x="26.6758"
      y="34.291"
      width="8.92554"
      height="1.48759"
      rx="0.595036"
      fill="url(#paint10_radial_410_32631)"
    />
    <path
      d="M48.7227 28.457C48.7227 28.1908 48.5604 27.9514 48.3131 27.8529L43.1217 25.7839L42.1443 25.6893C41.9593 25.6714 41.7726 25.6933 41.5968 25.7537L35.4438 27.8654C35.181 27.9555 35.0045 28.2027 35.0045 28.4805V36.7099C35.0045 37.9199 35.6162 39.0479 36.6303 39.7079L41.6554 42.9787C41.7895 43.066 41.951 43.1008 42.1091 43.0764L42.9188 42.9519L47.2757 39.7223C48.1859 39.0476 48.7227 37.9816 48.7227 36.8486V28.457Z"
      fill="#A3B1D1"
    />
    <path
      d="M49.6953 28.4805C49.6953 28.2027 49.5188 27.9555 49.256 27.8654L43.2585 25.807C42.9848 25.7131 42.6876 25.7131 42.414 25.807L36.4164 27.8654C36.1536 27.9555 35.9772 28.2027 35.9772 28.4805V36.7099C35.9772 37.9199 36.5888 39.0479 37.6029 39.7079L42.4814 42.8833C42.6971 43.0237 42.9753 43.0237 43.191 42.8833L48.0695 39.7079C49.0836 39.0479 49.6953 37.9199 49.6953 36.7099V28.4805Z"
      fill="url(#paint11_radial_410_32631)"
    />
    <g filter="url(#filter0_i_410_32631)">
      <path
        d="M48.1562 29.9019C48.1562 29.6243 47.98 29.3772 47.7174 29.2869L43.2625 27.7549C42.9883 27.6606 42.6906 27.6606 42.4164 27.7549L37.9615 29.2869C37.6989 29.3772 37.5226 29.6243 37.5226 29.9019V35.7598C37.5226 36.9686 38.1331 38.0956 39.1456 38.756L42.4841 40.9335C42.7001 41.0743 42.9788 41.0743 43.1948 40.9335L46.5333 38.756C47.5458 38.0956 48.1562 36.9686 48.1562 35.7598V29.9019Z"
        fill="url(#paint12_radial_410_32631)"
      />
    </g>
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M41.5488 33.1002V32.2077C41.5488 31.892 41.6742 31.5893 41.8974 31.3661C42.1205 31.143 42.4232 31.0176 42.7389 31.0176C43.0545 31.0176 43.3572 31.143 43.5804 31.3661C43.8036 31.5893 43.9289 31.892 43.9289 32.2077V33.1002H44.2265C44.3843 33.1002 44.5356 33.1629 44.6472 33.2745C44.7588 33.3861 44.8215 33.5374 44.8215 33.6952V35.7779C44.8215 35.9357 44.7588 36.087 44.6472 36.1986C44.5356 36.3102 44.3843 36.3729 44.2265 36.3729H41.2513C41.0935 36.3729 40.9421 36.3102 40.8305 36.1986C40.7189 36.087 40.6562 35.9357 40.6562 35.7779V33.6952C40.6562 33.5374 40.7189 33.3861 40.8305 33.2745C40.9421 33.1629 41.0935 33.1002 41.2513 33.1002H41.5488ZM42.1438 32.2077C42.1438 32.0498 42.2065 31.8985 42.3181 31.7869C42.4297 31.6753 42.5811 31.6126 42.7389 31.6126C42.8967 31.6126 43.048 31.6753 43.1596 31.7869C43.2712 31.8985 43.3339 32.0498 43.3339 32.2077V33.1002H42.1438V32.2077Z"
      fill="url(#paint13_radial_410_32631)"
    />
    <defs>
      <filter
        id="filter0_i_410_32631"
        x="37.5234"
        y="27.6836"
        width="10.6328"
        height="13.3555"
        filterUnits="userSpaceOnUse"
        color-interpolation-filters="sRGB"
      >
        <feFlood flood-opacity="0" result="BackgroundImageFix" />
        <feBlend
          mode="normal"
          in="SourceGraphic"
          in2="BackgroundImageFix"
          result="shape"
        />
        <feColorMatrix
          in="SourceAlpha"
          type="matrix"
          values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0"
          result="hardAlpha"
        />
        <feOffset dx="-0.297518" />
        <feComposite in2="hardAlpha" operator="arithmetic" k2="-1" k3="1" />
        <feColorMatrix
          type="matrix"
          values="0 0 0 0 0.639216 0 0 0 0 0.694118 0 0 0 0 0.819608 0 0 0 1 0"
        />
        <feBlend
          mode="normal"
          in2="shape"
          result="effect1_innerShadow_410_32631"
        />
      </filter>
      <radialGradient
        id="paint0_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(59.3485 -11.1692) rotate(116.338) scale(74.9768 76.8561)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint1_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(36.2348 30.6911) rotate(-112.272) scale(16.9081 23.0095)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint2_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(51.5185 46.0418) rotate(-129.519) scale(41.846 45.8238)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint3_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(41.3846 10.8152) rotate(127.574) scale(26.6207 9.54311)"
      >
        <stop stop-color="#A3B1D1" />
        <stop offset="1" stop-color="white" />
      </radialGradient>
      <radialGradient
        id="paint4_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.5537 18.5941) rotate(4.3184) scale(11.739 2.38624)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint5_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.1147 20.975) rotate(8.58828) scale(5.91918 2.3662)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint6_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.4609 24.2484) rotate(2.12685) scale(23.8178 2.39139)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint7_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.4609 26.9261) rotate(2.12685) scale(23.8178 2.39139)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint8_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.4609 32.2797) rotate(2.12685) scale(23.8178 2.39139)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint9_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(28.139 29.6019) rotate(2.59418) scale(19.5294 2.39058)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint10_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(27.5537 34.9594) rotate(4.3184) scale(11.739 2.38624)"
      >
        <stop stop-color="#D5DDEA" />
        <stop offset="1" stop-color="#DFE4EC" />
      </radialGradient>
      <radialGradient
        id="paint11_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(32.6429 47.2265) rotate(-51.922) scale(27.6496 29.9448)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
      <radialGradient
        id="paint12_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(39.3326 24.0336) rotate(71.4244) scale(19.6496 15.2966)"
      >
        <stop stop-color="#EAEEF9" />
        <stop offset="1" stop-color="#A3B1D1" />
      </radialGradient>
      <radialGradient
        id="paint13_radial_410_32631"
        cx="0"
        cy="0"
        r="1"
        gradientUnits="userSpaceOnUse"
        gradientTransform="translate(45.8339 37.6348) rotate(-127.784) scale(8.45067 9.12857)"
      >
        <stop stop-color="#EDF0F6" />
        <stop offset="1" stop-color="#FAFBFD" />
      </radialGradient>
    </defs>
  </svg>
</template>
